import { render, staticRenderFns } from "./UpdateDirectDeliveryRemarkDialog.vue?vue&type=template&id=3a96328e&scoped=true"
import script from "./UpdateDirectDeliveryRemarkDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDirectDeliveryRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateDirectDeliveryRemarkDialog.vue?vue&type=style&index=0&id=3a96328e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96328e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a96328e')) {
      api.createRecord('3a96328e', component.options)
    } else {
      api.reload('3a96328e', component.options)
    }
    module.hot.accept("./UpdateDirectDeliveryRemarkDialog.vue?vue&type=template&id=3a96328e&scoped=true", function () {
      api.rerender('3a96328e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateDirectDeliveryRemarkDialog.vue"
export default component.exports